/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Subscribe_To_Convert_AllInputs */

const en_read_along_subscribe_to_convert_all = /** @type {(inputs: Read_Along_Subscribe_To_Convert_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to convert the whole document.`)
};

const es_read_along_subscribe_to_convert_all = /** @type {(inputs: Read_Along_Subscribe_To_Convert_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscríbete para convertir el documento completo.`)
};

/**
* | output |
* | --- |
* | "Subscribe to convert the whole document." |
*
* @param {Read_Along_Subscribe_To_Convert_AllInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_subscribe_to_convert_all = /** @type {((inputs?: Read_Along_Subscribe_To_Convert_AllInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Subscribe_To_Convert_AllInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_subscribe_to_convert_all(inputs)
	return en_read_along_subscribe_to_convert_all(inputs)
});